
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-stepper-pedido',
  templateUrl: './stepper-pedido.component.html',
  styleUrls: ['./stepper-pedido.component.css']
})
export class StepperPedidoComponent implements OnInit {

  constructor() { }

  @Input()
  currentStep = 1;
  
  ngOnInit() {
  }

  number = [1,2,3];
  total = 3;

  getIcon(step){
    switch(step){
      case 1: return "file";
      case 2: return "truck";
      case 3: return "check";
    }
  }
}
